import Api from '../../../common/api/index';

const urlBase = '/api/v1/bot/warehouses/warehouse_rentals/';

export function createWarehouserental(params) {
  return Api().post(urlBase, params);
}

export function getCountryInformation(countryId = 0) {
  return Api().get(`${urlBase}country_information/${countryId}`);
}